import { SelectChangeEvent } from '@mui/material'
import { DecisionEnum } from '../../StockAdjustmentInBatchTypes'
import * as S from './PendingAdjustmentSelect.styles'

interface PendingAdjustmentSelectProps {
  setDecision: (string) => void
  setSelectError: (boolean) => void
  decision: string | undefined
  selectError: boolean
}

export default ({
  setDecision,
  selectError,
  setSelectError,
  decision,
}: PendingAdjustmentSelectProps) => {
  const optionsStock = [
    {
      id: 1,
      description: 'Em ambos',
      value: DecisionEnum.BOTH,
    },
    {
      id: 2,
      description: 'Apenas no Estoque Fiscal',
      value: DecisionEnum.MAIN_STOCK_ONLY,
    },
    {
      id: 3,
      description: 'Apenas no Estoque Operacional',
      value: DecisionEnum.WSS_STOCK_ONLY,
    },
  ]

  const onChangeStock = (event: SelectChangeEvent<unknown>) => {
    setDecision(optionsStock.find((option) => option.id === event.target.value)?.value)
    setSelectError(false)
  }

  return (
    <>
      <S.CustomSelect
        autoComplete='off'
        value={optionsStock.find((option) => option.value === decision)?.id}
        error={selectError}
        helperText={selectError ? 'Selecione uma opção' : ''}
        id='decision-select'
        label='Selecione uma opção'
        variant='outlined'
        options={optionsStock}
        onChange={onChangeStock}
        optionNone={false}
        type='text'
        fullWidth
      />
    </>
  )
}
